import { render, staticRenderFns } from "./LastLogins.vue?vue&type=template&id=0cc3fb38"
import script from "./LastLogins.vue?vue&type=script&lang=js"
export * from "./LastLogins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports